import { createFileRoute } from "@tanstack/react-router";
import { AuthLayout } from "@/shared/layouts/auth-layout";
import { VerifyEmailPage } from "@/shared/pages/auth/verify-email";
import { z } from "zod";

const verifyEmailSearchSchema = z.object({
  email: z.string().optional(),
});

export const Route = createFileRoute("/auth/verify-email")({
  validateSearch: verifyEmailSearchSchema,
  component: VerifyEmailRoute,
});

function VerifyEmailRoute() {
  return (
    <AuthLayout>
      <VerifyEmailPage />
    </AuthLayout>
  );
}
